import React from "react";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

export default function PersonalReceptTable(props) {
  const { bills, sumation, subTitle } = props;
  console.log(props.bills);
  return (
    <div style={{ width: "20cm", margin: "auto" }}>
      {bills && (
        <div style={{ background: "#fff" }}>
          <div
            style={{
              textAlign: "center",
              paddingTop: "0cm",
              marginBottom: ".5cm",
            }}
          >
            <h2 style={{ fontSize: "16pt" }}>หลักฐานการส่งเงิน</h2>
            <div style={{ fontWeight: 400 }}>{subTitle}</div>
          </div>
          <Table style={{ border: "1px solid #111" }}>
            <TableHead>
              <TableRow>
                <TableCell className="underLineTd">ประเภทรายได้</TableCell>
                <TableCell className="underLineTd" style={{ width: "2.5cm" }}>
                  การรับเงิน
                </TableCell>
                <TableCell className="underLineTd" style={{ width: "5cm" }}>
                  ใบเสร็จเลขที่
                </TableCell>
                <TableCell className="underLineTd" style={{ width: "2.5cm" }}>
                  จำนวนเงิน
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {bills.map((bill) => (
                <TableRow key={bill._id}>
                  <TableCell className="underLineTd">
                    {bill.details.map((detail, key) => (
                      <div key={key} style={{ paddingLeft: "10px" }}>
                        <div>
                          <span style={{ marginRight: "10px" }}>
                            {key + 1}.
                          </span>
                          {detail.biller_name}
                        </div>
                      </div>
                    ))}
                  </TableCell>
                  <TableCell align="center" className="underLineTd">
                    {bill.transactionType === "Pay by Cash"
                      ? "เงินสด"
                      : "เงินโอน"}
                  </TableCell>
                  <TableCell align="center" className="underLineTd">
                    {bill.bill_id}
                  </TableCell>
                  <TableCell align="right" className="underLineTd">
                    {bill.details.map((detail, key) => (
                      <div key={key}>
                        {parseFloat(detail.amount).toLocaleString()}
                      </div>
                    ))}
                    {/* <div style={{ paddingRight: ".3cm" }}>
                        {parseFloat(bill.amount).toLocaleString()}
                      </div> */}
                  </TableCell>
                </TableRow>
              ))}
              <TableRow>
                <TableCell
                  colSpan={2}
                  align="right"
                  className="underLineTd bold-500"
                >
                  รวมเป็นเงิน
                </TableCell>
                <TableCell align="right" className="underLineTd bold-500">
                  {sumation.amount.toLocaleString()}
                </TableCell>
                <TableCell className="underLineTd bold-500">บาท</TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  colSpan={2}
                  align="right"
                  className="underLineTd bold-500"
                >
                  เงินสด
                </TableCell>
                <TableCell align="right" className="underLineTd bold-500">
                  {sumation.cash.toLocaleString()}
                </TableCell>
                <TableCell className="underLineTd bold-500">บาท</TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  colSpan={2}
                  align="right"
                  className="underLineTd bold-500"
                >
                  เงินโอน
                </TableCell>
                <TableCell align="right" className="underLineTd bold-500">
                  {sumation.tranfer.toLocaleString()}
                </TableCell>
                <TableCell className="underLineTd bold-500">บาท</TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  colSpan={2}
                  align="right"
                  className="underLineTd bold-500"
                >
                  รายการยกเลิก
                </TableCell>
                <TableCell align="right" className="underLineTd bold-500">
                  {sumation.canceled.toLocaleString()}
                </TableCell>
                <TableCell className="underLineTd bold-500">รายการ</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </div>
      )}
    </div>
  );
}
